import { Component, Input } from '@angular/core'
import { AutomationEventTypes, AutomationTypes } from '@tokeet-frontend/automations'
import { FormBuilder } from '@angular/forms'
import { Store } from '@ngrx/store'
import { AutomationWizardPanelBaseComponent } from '@tv3/containers/automations/automations-wizard/automation-wizard-panel.component'
import { userTaskNotificationMessages } from '@tv3/containers/automations/automations-wizard/task/messages'
import { Actions } from '@ngrx/effects'

@Component({
  selector: 'app-task-automation-wizard',
  templateUrl: './task-automation-wizard.component.html',
  styleUrls: ['./task-automation-wizard.component.scss'],
})
export class TaskAutomationWizardComponent extends AutomationWizardPanelBaseComponent {
  type = AutomationTypes.Task

  constructor(protected fb: FormBuilder, protected actions: Actions, protected store: Store<any>) {
    super(actions, store, fb)
    this.form.patchValue({ event: AutomationEventTypes.TaskCreated })
  }

  userNotificationMessages = userTaskNotificationMessages
}
